import React from "react";
import { images } from "../data/images";
import { Reveal } from "./Reveal";
const moments = [{
  src: images.breakfast,
  caption: "Manhãs sem pressa",
  className: "lg:col-span-7 lg:mt-24"
}, {
  src: images.bay,
  caption: "Entre o verde e o mar",
  className: "lg:col-span-5"
}, {
  src: images.hammock,
  caption: "Momentos para guardar",
  className: "lg:col-span-8 lg:col-start-3"
}];
export function Moments() {
  return <section id="experiencias" className="scroll-mt-20 bg-white py-24 md:py-36" data-id="element-126" data-mp="2cq5ulxjiqf21">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8" data-id="element-127" data-mp="2hn65clrbc5zh">
        <Reveal className="mb-16 max-w-3xl md:mb-24" data-id="element-128" data-mp="2hllb6x8wup25">
          <p className="mb-6 text-[11px] font-bold tracking-[0.25em] text-[#566C63]" data-id="element-129" data-mp="2mm8xx6q3wjqk">VIVER ANGRA</p>
          <h2 className="font-serif text-[clamp(3rem,6vw,6rem)] leading-[.96] tracking-[-0.03em] text-[#033448]" data-id="element-130" data-mp="2reiu34hteg1a">O tempo encontra<br data-id="element-131" data-mp="1ty3cehr8aqpo" /><span className="italic" data-id="element-132" data-mp="1tw91lw9o8ezb">outro ritmo</span> aqui.</h2>
        </Reveal>
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-7" data-id="element-133" data-mp="1yvvdo2drjp6j">
          {moments.map((moment, index) => <Reveal key={moment.caption} className={moment.className} delay={index * 0.06} data-id="element-134" data-mp="cijpkzgitaan" data-mpi={index}>
              <figure data-id="element-135" data-mp="7kryu8rm3u81">
                <div className={`overflow-hidden ${index === 0 ? "aspect-[4/3]" : index === 1 ? "aspect-[3/4]" : "aspect-[16/9]"}`} data-id="element-136" data-mp="7mkw4xgc523d">
                  <img src={moment.src} alt={`Imagem ilustrativa: ${moment.caption.toLowerCase()}`} className="h-full w-full object-cover transition-transform duration-700 hover:scale-[1.02]" loading="lazy" data-id="element-137" data-mp="3uxuc5wu0n1o7" />
                </div>
                <figcaption className="mt-4 flex items-center gap-3 font-serif text-xl text-[#172B32]" data-id="element-138" data-mp="3kyd3r7ndq9oj"><span className="h-px w-8 bg-[#D4B581]" data-id="element-139" data-mp="3g136x6xnuvqo" />{moment.caption}</figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}